import React from 'react';
import { Button } from './ui/Button';
import { Clock } from 'lucide-react';
export function EducationSection() {
  return <section className="flex flex-col lg:flex-row min-h-[600px]" data-id="element-102">
      {/* Left Content Side */}
      <div className="w-full lg:w-1/2 bg-[#0A5E5C] p-10 md:p-16 lg:p-24 flex flex-col justify-center text-white" data-id="element-103">
        <span className="inline-flex items-center gap-2 self-start py-1 px-3 rounded-full bg-[#D4A843]/20 text-[#D4A843] border border-[#D4A843]/30 text-sm font-medium mb-6" data-id="element-104">
          <Clock size={14} data-id="element-105" />У розробці
        </span>

        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-106">
          Освіта та навчання
        </h2>

        <p className="text-white/80 text-lg mb-10 leading-relaxed" data-id="element-107">
          Освіта — це ключ до безпечної і чесної гри. Зараз ми розробляємо серію
          освітніх, просвітницьких вебінарів та програм, які допоможуть
          підвищити обізнаність про ризики та правила відповідальної гри. Наші
          майбутні курси допоможуть зрозуміти, як працює індустрія, які ризики
          вона може нести, а також як їх мінімізувати.
        </p>

        <p className="text-white/60 text-sm uppercase tracking-wider mb-4" data-id="element-108">
          Курси, над якими ми працюємо
        </p>

        <ul className="space-y-4 mb-12" data-id="element-109">
          {['Захист прав гравців', 'Освітня інформація для батьків', 'Відповідальна гра', 'Як працює ринок азартних ігор'].map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-110">
              <div className="flex-shrink-0 w-6 h-6 rounded-full bg-white/10 flex items-center justify-center text-[#D4A843]" data-id="element-111">
                <Clock size={13} strokeWidth={2.5} data-id="element-112" />
              </div>
              <span className="text-lg font-medium" data-id="element-113">{item}</span>
              <span className="text-xs text-white/50 border border-white/20 rounded-full px-2 py-0.5" data-id="element-114">
                Скоро
              </span>
            </li>)}
        </ul>

        <div data-id="element-115">
          <Button variant="secondary" size="lg" disabled data-id="element-116">
            Курси у розробці — незабаром
          </Button>
        </div>
      </div>

      {/* Right Image Side */}
      <div className="w-full lg:w-1/2 relative min-h-[400px]" data-id="element-117">
        <img src="https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=1000&h=1000&fit=crop&q=80" alt="Людина йде по лісовій стежці" className="absolute inset-0 w-full h-full object-cover" data-id="element-118" />
        <div className="absolute inset-0 bg-[#0A5E5C]/20 mix-blend-multiply" data-id="element-119" />
      </div>
    </section>;
}